import React from 'react';
import {
    getReminderItems,
    getReminderPillClassName,
    getReminderTooltipText,
} from './subparts/appointmentsQuery';

const REMINDER_GLYPHS = {
    prebooked: 'P',
    first: '1',
    second: '2',
    last: 'L',
    sameDay: 'S',
};

function AppointmentReminderPills({ appointmentStatus }) {
    const reminders = getReminderItems(appointmentStatus || {});

    return (
        <div className="appointments-reminder-pills" aria-label="Reminder status">
            {reminders.map((reminder) => {
                const tooltipText = getReminderTooltipText(reminder);
                const glyph = REMINDER_GLYPHS[reminder.key] || reminder.shortLabel?.charAt(0) || '•';

                return (
                    <span
                        key={reminder.key}
                        className={`appointments-reminder-pill ${getReminderPillClassName(reminder)}`}
                        tabIndex={0}
                        aria-label={tooltipText}
                    >
                        <span className="appointments-reminder-pill__glyph" aria-hidden="true">
                            {glyph}
                        </span>
                        {reminder.isSent && (
                            <i
                                className={`bi ${reminder.channelIcon.icon} appointments-reminder-pill__channel`}
                                aria-hidden="true"
                            />
                        )}
                        {reminder.responseStatus && (
                            <span className="appointments-reminder-pill__confirmed" aria-hidden="true">
                                <i className="bi bi-check2" />
                            </span>
                        )}

                        <span className="appointments-reminder-tooltip" role="tooltip">
                            {tooltipText}
                        </span>
                    </span>
                );
            })}
        </div>
    );
}

export default AppointmentReminderPills;
